import { StateCreator } from 'zustand';

interface OnboardingRecommendedActionsState {
    hiddenRecommendedActionsKeys: string[];
    hideRecommendedActionsKey: (keyToHide: string) => void;

    completableRecommendedActionsKeys: string[];
    setCompletableRecommendedActionsKeys: (keys: string[]) => void;

    seeMoreRecommendedActions: boolean;
    toggleSeeMoreRecommendedActions: () => void;

    hasSeenCompleteAllRecommendedActionsDialog: boolean;
    setHasSeenCompleteAllRecommendedActionsDialog: (hasSeen: boolean) => void;
}

const createOnboardingRecommendedActionsSlice: StateCreator<
    any,
    [['zustand/persist', unknown]],
    [],
    OnboardingRecommendedActionsState
> = set => ({
    completableRecommendedActionsKeys: [],
    hiddenRecommendedActionsKeys: [],
    hasSeenCompleteAllRecommendedActionsDialog: false,
    seeMoreRecommendedActions: false,

    hideRecommendedActionsKey: keyToHide =>
        set(
            (state: {
                hiddenRecommendedActionsKeys: OnboardingRecommendedActionsState['hiddenRecommendedActionsKeys'];
            }) => ({
                hiddenRecommendedActionsKeys: Array.from(
                    new Set(state.hiddenRecommendedActionsKeys).add(keyToHide),
                ),
            }),
        ),
    setCompletableRecommendedActionsKeys: keys =>
        set({
            completableRecommendedActionsKeys: Array.from(new Set(keys)),
        }),

    toggleSeeMoreRecommendedActions: () =>
        set(
            (state: {
                seeMoreRecommendedActions: OnboardingRecommendedActionsState['seeMoreRecommendedActions'];
            }) => ({
                seeMoreRecommendedActions: !state.seeMoreRecommendedActions,
            }),
        ),

    setHasSeenCompleteAllRecommendedActionsDialog: hasSeen =>
        set({
            hasSeenCompleteAllRecommendedActionsDialog: hasSeen,
        }),
});

export { createOnboardingRecommendedActionsSlice };
export type { OnboardingRecommendedActionsState };
